export const HIDE_ALL_DIALOGS = 'HIDE_ALL_DIALOGS'
export const SHOW_DELETE_DIALOG = 'SHOW_DELETE_DIALOG'
export const SHOW_EDIT_DIALOG = 'SHOW_EDIT_DIALOG'
export const SET_INNOVATION_FIELD = 'SET_INNOVATION_FIELD'
export const SET_CREATED_NEW = 'SET_CREATED_NEW'
